import { Fragment, useRef } from 'react'

import { Seo } from '../components'
import Button from '../components/tailwind/Button'
import PageHeading from '../components/tailwind/PageHeading'
import { useUserContext } from '../context'
import AssistantLauncher from '../features/assistant-intro/AssistantLauncher'
import DemoChat from '../features/assistant-intro/DemoChat'

// Interne Showcase-Seite (nicht in der Sidebar verlinkt). Der Chat ist eine Demo ohne Backend.

const AssistantLauncherPage = () => {
  const launcherRef = useRef(null)
  const { activeSpace } = useUserContext()
  const person = activeSpace?.person || {}
  const userName = person.firstname || person.invitation_firstname

  return (
    <Fragment>
      <Seo title='Aivy Assistent Launcher' />
      <PageHeading
        title='Aivy Assistent Launcher'
        subtitle='Karl Klammer wird zum Aivy Assistenten, direkt im Button unten rechts'
        withActions={
          <Button.SecondaryXL
            onClick={() => launcherRef.current?.replay()}
            text='Intro nochmal abspielen'
          />
        }
      />
      <div className='max-w-3xl px-4 py-8 text-sm leading-relaxed text-gray-700 sm:px-6 lg:px-8'>
        <p>
          Unten rechts sitzt der Launcher. Beim ersten Besuch steht dort Karl
          Klammer aus Office 97, damit jeder sofort erkennt, was gemeint ist.
          Danach wird er zur modernen Aivy-Klammer, und die ist ab dann der
          Button für den Chat.
        </p>
        <p className='mt-3'>
          Im echten Einsatz läuft das Intro nur einmal pro Browser. Auf dieser
          Seite startet es bei jedem Aufruf. Der Chat ist eine Demo ohne
          Backend.
        </p>
      </div>
      <AssistantLauncher
        userName={userName}
        tooltipText='Heute sind 3 neue Ergebnisse reingekommen. Soll ich sie dir zeigen?'
        ref={launcherRef}
        intro='always'
      >
        <DemoChat />
      </AssistantLauncher>
    </Fragment>
  )
}

export default AssistantLauncherPage
